import React from "react";

export const UserIcon: React.FC = () => {
  return (
    <svg
      width="17px"
      height="17px"
      viewBox="0 0 17 17"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <desc>Created with sketchtool.</desc>
      <g
        id="Page-1"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="CareGEM-MyProfile-V1.1"
          transform="translate(-1100.000000, -67.000000)"
          fill="#212B40"
        >
          <g id="Group-4" transform="translate(1083.000000, 43.000000)">
            <path
              d="M25.012,32.995509 C25.9875179,32.995509 27.0749641,33.1474316 28.2743713,33.4512814 C29.6177073,33.7871155 30.7051535,34.2348874 31.5367425,34.7946108 C32.5282525,35.4662788 33.024,36.2099001 33.024,37.025497 L33.024,40.024 L17,40.024 L17,37.025497 C17,36.2099001 17.4957475,35.4662788 18.4872575,34.7946108 C19.3188465,34.2348874 20.4062927,33.7871155 21.7496287,33.4512814 C22.9490359,33.1474316 24.0364821,32.995509 25.012,32.995509 Z M25.012,24 C25.7316443,24 26.3953063,24.1799084 27.003006,24.5397305 C27.6107056,24.8995527 28.0944593,25.3913023 28.4542814,26.014994 C28.8141036,26.6386858 28.994012,27.3103437 28.994012,28.029988 C28.994012,28.7496323 28.8141036,29.4132944 28.4542814,30.020994 C28.0944593,30.6286937 27.6107056,31.1124473 27.003006,31.4722695 C26.3953063,31.8320916 25.7316443,32.012 25.012,32.012 C24.2923557,32.012 23.6286937,31.8320916 23.020994,31.4722695 C22.4132944,31.1124473 21.9295407,30.6286937 21.5697186,30.020994 C21.2098964,29.4132944 21.029988,28.7496323 21.029988,28.029988 C21.029988,27.3103437 21.2098964,26.6386858 21.5697186,26.014994 C21.9295407,25.3913023 22.4132944,24.8995527 23.020994,24.5397305 C23.6286937,24.1799084 24.2923557,24 25.012,24 Z M25.012,34.9145509 C24.1004505,34.9145509 23.1329432,35.0504817 22.1094491,35.3223473 C21.2298838,35.5622287 20.4782666,35.8500822 19.8545749,36.1859162 C19.2308831,36.5217502 18.9190419,36.8016077 18.9190419,37.025497 L18.9190419,38.1049581 L31.1049581,38.1049581 L31.1049581,37.025497 C31.1049581,36.8016077 30.7931169,36.5217502 30.1694251,36.1859162 C29.5457334,35.8500822 28.7941162,35.5622287 27.9145509,35.3223473 C26.8910568,35.0504817 25.9235495,34.9145509 25.012,34.9145509 Z M25.012,25.9190419 C24.4202925,25.9190419 23.9205469,26.1229381 23.5127485,26.5307365 C23.1049501,26.938535 22.9010539,27.4382805 22.9010539,28.029988 C22.9010539,28.6216956 23.1049501,29.1134451 23.5127485,29.5052515 C23.9205469,29.8970578 24.4202925,30.0929581 25.012,30.0929581 C25.6037075,30.0929581 26.1034531,29.8970578 26.5112515,29.5052515 C26.9190499,29.1134451 27.1229461,28.6216956 27.1229461,28.029988 C27.1229461,27.4382805 26.9190499,26.938535 26.5112515,26.5307365 C26.1034531,26.1229381 25.6037075,25.9190419 25.012,25.9190419 Z"
              id=""
            ></path>
          </g>
        </g>
      </g>
    </svg>
  );
};
